import { render, staticRenderFns } from "./RecordActionButton.vue?vue&type=template&id=e5ddc310&"
import script from "./RecordActionButton.vue?vue&type=script&lang=js&"
export * from "./RecordActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports